import React, {Fragment} from 'react';
import { translate } from 'react-i18next';
import {connect} from 'react-redux';
import { compose } from 'redux';
import FileMappingWizardComponentList from "../../../scenes/data-manager/file-mapping/wizard/component-list";
import { selectELMappingColumn } from './actions';

const mapStateToProps = state => ({
  selectedColumnName: state.scenes.easyLoading.selectedColumnName,
  components: state.scenes.easyLoading.components   
});

const mapDispatchToProps = dispatch => ({
  onColumnSelect: columnName => dispatch(selectELMappingColumn(columnName)),
});

const ELCsvHeaderList = ({
              t,
              csvHeader,
              selectedColumnName,
              components,
              selectedMapping,
              onColumnSelect
              }) => {

  const handleColumnSelect = (name) => {
    if (selectedMapping === -1) {
      onColumnSelect(name);
    }
  }                

  return (
    <Fragment>
      <FileMappingWizardComponentList
        components={
        csvHeader !== null
            ? (
            csvHeader.map((name, idx) => ({
                name: name,
                key: idx,
                detailTitle: t('components.easyLoading.steps.mapping.csvComponentList.detail.title'),
                onDetail: null
            }))
            )
            : []
        }
        selected={
          selectedColumnName !== null
            ? selectedColumnName
            : null
        }
        onSelect={({name}) => handleColumnSelect(name)}
        disabled={components.map(comp => comp.columnName)}
    />
    </Fragment>
  )
};

export default compose(
    translate(),
    connect(mapStateToProps, mapDispatchToProps)
)(ELCsvHeaderList);




// WEBPACK FOOTER //
// ./src/components/easy-loading/mapping-step/ELCsvHeaderList.jsx